export default {
    name: 'employee_agb',
    definition: {
        agb: '',
        caregiver_specification_id: '',
        summary: '',
        sequence_number: 0,
    },
};
